import request from "@utils/request";

export function getDailyLoser(query) {
    return request({
        url: 'alert/data/daily-loser',
        method: 'get',
        params: query
    })
}
